import { prop, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';

import { NAME, toggleButtonGroupValues } from './constants';

const getRoot = prop(NAME);

export const getAvailableLeads = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'availableLeads'));
export const getAvailableLeadsSplitted = createSelector(getAvailableLeads, (leads) => {
	const leadsToShow = leads.slice(0, 3);
	return { leadsToShow, originalLength: leads.length };
});

export const getTakenOrInProgressLeads = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'takenOrInProgressLeads'));
export const getTakenOrInProgressLeadsSplitted = createSelector(getTakenOrInProgressLeads, (leads) => {
	const leadsToShow = leads.slice(0, 3);
	return { leadsToShow, originalLength: leads.length };
});

export const getToggleValue = createSelector(getRoot, propOr(toggleButtonGroupValues.TAKEN, 'toggleValue'));
